import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const DisclaimerContainer = styled.div`
    font-family: Lato;
    font-size: 8px;
    line-height: 1.33;
    color: #979191;
    width: 100%;

    @media (min-width: 30em) {
        width: 135px;
    }
`;

const getDisclaimerText = paymentMethod => {
    let disclaimerText = 'Action Button takes no proceeds from your donation.';

    if (paymentMethod === 'Braintree')
        disclaimerText += ' Payment processed by Braintree, a PayPal company.';

    if (paymentMethod === 'PandaPay') disclaimerText += ' Payment processed by PandaPay.';

    return disclaimerText;
};

const Disclaimer = props => (
    <DisclaimerContainer>{getDisclaimerText(props.paymentMethod)}</DisclaimerContainer>
);

Disclaimer.propTypes = {
    paymentMethod: PropTypes.string.isRequired
};

export default Disclaimer;



// WEBPACK FOOTER //
// ./src/components/Donation/Disclaimer.jsx